import * as types from './constants';
import constantService from '../../services/constantService';
// eslint-disable-next-line import/prefer-default-export
export const fetchCountries = () => async dispatch => {
  try {
    dispatch({ type: types.CONSTANT_LOADING });
    const countries = await constantService.fetchCountries();
    dispatch({
      type: types.FETCH_COUNTRIES_SUCCESS,
      payload: countries?.nationalities,
    });
  } catch (error) {
    dispatch({ type: types.CONSTANT_ERROR, payload: error });
  }
};

export const fetchBanks = () => async dispatch => {
  try {
    dispatch({ type: types.CONSTANT_LOADING });
    const banks = await constantService.fetchBanks();
    dispatch({
      type: types.FETCH_BANKS_SUCCESS,
      payload: banks?.items,
    });
  } catch (error) {
    dispatch({ type: types.CONSTANT_ERROR, payload: error });
  }
};
